/* Theme-owned links only; no store writes. Details also work without JS. */
if (!customElements.get('occ-navigation')) {
  customElements.define('occ-navigation', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort(); this.events = new AbortController();
      const options = {signal: this.events.signal};
      const details = this.querySelector('details'), toggle = this.querySelector('summary');
      if (!details || !toggle) return;
      const sync = () => { toggle.setAttribute('aria-expanded', String(details.open)); if (this.classList.contains('occ-nav--mobile')) toggle.setAttribute('aria-label', details.open ? 'Close shopping menu' : 'Open shopping menu'); };
      const close = (restore = false) => { details.open = false; sync(); if (restore) toggle.focus(); };
      details.addEventListener('toggle', sync, options);
      this.addEventListener('keydown', e => { if (e.key === 'Escape' && details.open) { e.preventDefault(); e.stopPropagation(); close(true); } }, options);
      this.addEventListener('focusout', e => { if (e.relatedTarget && !this.contains(e.relatedTarget)) close(); else if (!e.relatedTarget) setTimeout(() => { if (this.isConnected && !this.contains(document.activeElement)) close(); }, 0); }, options);
      document.addEventListener('pointerdown', e => { if (!this.contains(e.target)) close(); }, options);
      this.querySelectorAll('a').forEach(link => link.addEventListener('click', () => close(), options));
      matchMedia('(max-width:989px)').addEventListener('change', () => close(), options);
      sync();
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}
